import type { PropsWithChildren, ReactNode } from "react";

type StatusTone = "neutral" | "info" | "success" | "warning" | "pending" | "danger";

interface StatusPillProps extends PropsWithChildren {
  tone?: StatusTone;
  /** Leading glyph. Pass an already-`aria-hidden` icon; the label carries meaning. */
  icon?: ReactNode;
  size?: "small" | "medium";
  className?: string;
}

export function StatusPill({
  children,
  className,
  icon,
  size = "medium",
  tone = "neutral",
}: StatusPillProps) {
  const classes = ["status-pill", `status-pill--${tone}`, className].filter(Boolean).join(" ");
  return (
    <span className={classes} data-size={size}>
      {icon}
      {children}
    </span>
  );
}
